
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eTcMK", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ const $cae726f3aa41e4da$export$497a036b5874e4b0 = (parentCommentId, location, author, shouldIncludeUser)=>{
    return {
        parentCommentId: parentCommentId,
        location: location,
        user: author && shouldIncludeUser ? {
            displayName: author.displayName,
            accountId: author.accountId
        } : undefined
    };
};
module.exports["createReplyToCommentParams"] = $cae726f3aa41e4da$export$497a036b5874e4b0;

});

parcelRegister("ifBRq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $a33Aa = parcelRequire("a33Aa");


var $gczDe = parcelRequire("gczDe");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $lb2Lp = parcelRequire("lb2Lp");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $7aRa9 = parcelRequire("7aRa9");


var $ep3mz = parcelRequire("ep3mz");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $8WQTF = parcelRequire("8WQTF");


var $aSsfA = parcelRequire("aSsfA");


var $dPJCf = parcelRequire("dPJCf");


var $eTcMK = parcelRequire("eTcMK");


var $1ZGYV = parcelRequire("1ZGYV");

// Maximum wait time for scroll operations (in milliseconds)
const $4d5518b698c93929$var$SCROLL_TIMEOUT_MS = 4000;
// Minimum time page must be stable before scrolling (in milliseconds)
const $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS = 500;
// Wait for document height to stabilize (tables may have async layout)
const $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS = 150;
const $4d5518b698c93929$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    commentLinkNotFoundFlagTitle: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    }
});
// ---------------------------------------------------------------------------
// Query param hooks
// ---------------------------------------------------------------------------
const $4d5518b698c93929$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $4d5518b698c93929$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $4d5518b698c93929$var$useCommentQueryParamsData = (0, $3u0dr.isReactCompilerActiveV2)() ? function useCommentQueryParamsData(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { commentId: commentId, contentId: contentId } = t0;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let t1;
    if ($[0] !== pageMode) {
        t1 = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
        $[0] = pageMode;
        $[1] = t1;
    } else t1 = $[1];
    const contentStatusFilters = t1;
    const t2 = commentId || "";
    const t3 = contentId || "";
    const t4 = !commentId;
    let t5;
    if ($[2] !== t4) {
        t5 = {
            skip: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== contentStatusFilters || $[5] !== t2 || $[6] !== t3 || $[7] !== t5) {
        t6 = {
            commentId: t2,
            contentId: t3,
            contentStatus: contentStatusFilters,
            options: t5
        };
        $[4] = contentStatusFilters;
        $[5] = t2;
        $[6] = t3;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)(t6);
    const t7 = foundComment?.parentId || "";
    const t8 = contentId || "";
    const t9 = !foundComment?.parentId;
    let t10;
    if ($[9] !== t9) {
        t10 = {
            skip: t9
        };
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    let t11;
    if ($[11] !== contentStatusFilters || $[12] !== t10 || $[13] !== t7 || $[14] !== t8) {
        t11 = {
            commentId: t7,
            contentId: t8,
            contentStatus: contentStatusFilters,
            options: t10
        };
        $[11] = contentStatusFilters;
        $[12] = t10;
        $[13] = t7;
        $[14] = t8;
        $[15] = t11;
    } else t11 = $[15];
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)(t11);
    let isResolved = undefined;
    let parentId = undefined;
    if (foundComment && !commentError) {
        const loc = foundComment.location;
        if (loc?.type === "INLINE") isResolved = Boolean(loc?.inlineResolveProperties?.resolved);
        else isResolved = Boolean(loc?.commentResolveProperties?.resolved);
        parentId = foundComment.parentId;
    }
    const t12 = Boolean(commentError);
    const t13 = Boolean(parentError);
    let t14;
    if ($[16] !== commentId || $[17] !== commentLoading || $[18] !== foundComment || $[19] !== isResolved || $[20] !== parentComment || $[21] !== parentId || $[22] !== parentLoading || $[23] !== t12 || $[24] !== t13) {
        t14 = {
            commentId: commentId,
            foundComment: foundComment,
            parentComment: parentComment,
            commentLoading: commentLoading,
            commentError: t12,
            parentLoading: parentLoading,
            parentError: t13,
            isResolved: isResolved,
            parentId: parentId
        };
        $[16] = commentId;
        $[17] = commentLoading;
        $[18] = foundComment;
        $[19] = isResolved;
        $[20] = parentComment;
        $[21] = parentId;
        $[22] = parentLoading;
        $[23] = t12;
        $[24] = t13;
        $[25] = t14;
    } else t14 = $[25];
    return t14;
} : function useCommentQueryParamsData({ commentId: commentId, contentId: contentId }) {
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: !commentId
        }
    });
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)({
        commentId: foundComment?.parentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: !foundComment?.parentId
        }
    });
    // Derive isResolved + parentId from the comment
    let isResolved = undefined;
    let parentId = undefined;
    if (foundComment && !commentError) {
        const loc = foundComment.location;
        if (loc?.type === 'INLINE') isResolved = Boolean(loc?.inlineResolveProperties?.resolved);
        else isResolved = Boolean(loc?.commentResolveProperties?.resolved);
        parentId = foundComment.parentId;
    }
    return {
        commentId: commentId,
        foundComment: foundComment,
        parentComment: parentComment,
        commentLoading: commentLoading,
        commentError: Boolean(commentError),
        parentLoading: parentLoading,
        parentError: Boolean(parentError),
        isResolved: isResolved,
        parentId: parentId
    };
}; // ---------------------------------------------------------------------------
const $4d5518b698c93929$var$InlineCommentHandler = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(59);
    const { commentId: commentId, rendererRef: rendererRef, flags: flags, data: data } = t0;
    const hasHandledCommentLink = (0, $cozmU.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const { replyToCommentId: replyToCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)();
    const { foundComment: foundComment, parentComment: parentComment } = data;
    let t1;
    bb0: {
        if (!data.commentError && !data.commentLoading && foundComment) {
            const location = foundComment.location ?? undefined;
            const pid = foundComment.parentId;
            const parentLocation = pid && !data.parentError && !data.parentLoading && parentComment ? parentComment.location ?? undefined : undefined;
            if (!pid || parentComment) {
                let t2;
                if ($[0] !== location || $[1] !== parentLocation || $[2] !== pid) {
                    t2 = {
                        location: location,
                        parentId: pid,
                        parentLocation: parentLocation
                    };
                    $[0] = location;
                    $[1] = parentLocation;
                    $[2] = pid;
                    $[3] = t2;
                } else t2 = $[3];
                t1 = t2;
                break bb0;
            }
        }
        t1 = undefined;
    }
    const queryParamData = t1;
    let t2;
    if ($[4] !== queryParamData) {
        t2 = queryParamData || {};
        $[4] = queryParamData;
        $[5] = t2;
    } else t2 = $[5];
    const { location: loc, parentLocation: pLoc } = t2;
    let t3;
    if ($[6] !== loc || $[7] !== pLoc?.inlineMarkerRef || $[8] !== pLoc?.inlineResolveProperties?.resolved) {
        t3 = loc?.inlineMarkerRef ? {
            annotationId: loc.inlineMarkerRef,
            isResolved: Boolean(loc.inlineResolveProperties?.resolved)
        } : {
            annotationId: pLoc?.inlineMarkerRef,
            isResolved: Boolean(pLoc?.inlineResolveProperties?.resolved)
        };
        $[6] = loc;
        $[7] = pLoc?.inlineMarkerRef;
        $[8] = pLoc?.inlineResolveProperties?.resolved;
        $[9] = t3;
    } else t3 = $[9];
    const queryParamDataExt = t3;
    let t4;
    if ($[10] !== foundComment || $[11] !== queryParamDataExt.annotationId || $[12] !== replyToCommentId || $[13] !== setCurrentlySelectedThreadKey || $[14] !== setReplyToCommentId) {
        t4 = ()=>{
            if (!replyToCommentId) return;
            if (foundComment) {
                const annotationId = queryParamDataExt?.annotationId;
                if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
                const author = foundComment?.author;
                setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, true));
            }
        };
        $[10] = foundComment;
        $[11] = queryParamDataExt.annotationId;
        $[12] = replyToCommentId;
        $[13] = setCurrentlySelectedThreadKey;
        $[14] = setReplyToCommentId;
        $[15] = t4;
    } else t4 = $[15];
    const onReplyToCommentReady = t4;
    let t5;
    if ($[16] !== commentId || $[17] !== onReplyToCommentReady || $[18] !== queryParamData?.parentId || $[19] !== queryParamDataExt || $[20] !== setCurrentlySelectedThreadKey || $[21] !== showCommentsPanel) {
        t5 = ()=>{
            const { annotationId: annotationId_0 } = queryParamDataExt;
            showCommentsPanel({
                openWithView: (0, $3mVfX.ViewValues).OPEN
            });
            const mark = document.querySelector(`[data-id="${annotationId_0}"]`);
            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: "center",
                inline: "center",
                commentId: commentId ?? undefined,
                annotationId: annotationId_0,
                commentType: "INLINE",
                annotationClicked: true,
                expectedView: (0, $3mVfX.ViewValues).OPEN,
                isReply: Boolean(queryParamData?.parentId)
            }).then((success)=>{
                if (!success && mark) {
                    (0, $a33Aa.abortAll)("new_interaction", "focused-comment-scroll");
                    (0, $aHcFH.scrollToElementWithViewingRoom)({
                        element: mark,
                        useInstantScroll: true
                    });
                }
            });
            setCurrentlySelectedThreadKey(annotationId_0 ?? "", (0, $kgNLQ.CommentType).INLINE);
            (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
            hasHandledCommentLink.current = true;
        };
        $[16] = commentId;
        $[17] = onReplyToCommentReady;
        $[18] = queryParamData?.parentId;
        $[19] = queryParamDataExt;
        $[20] = setCurrentlySelectedThreadKey;
        $[21] = showCommentsPanel;
        $[22] = t5;
    } else t5 = $[22];
    const navigateToActiveInlineComment = t5;
    let t6;
    if ($[23] !== commentId || $[24] !== queryParamData?.parentId || $[25] !== queryParamDataExt.annotationId) {
        t6 = ()=>$4d5518b698c93929$var$tryToFocusAndScrollActiveComment({
                parentId: queryParamData?.parentId,
                annotationId: queryParamDataExt?.annotationId || null,
                commentId: commentId || null
            });
        $[23] = commentId;
        $[24] = queryParamData?.parentId;
        $[25] = queryParamDataExt.annotationId;
        $[26] = t6;
    } else t6 = $[26];
    const tryToFocusAndScrollActiveCommentCallback = t6;
    const t7 = !commentId || !queryParamData || queryParamDataExt.isResolved;
    let t8;
    if ($[27] !== rendererRef || $[28] !== t7 || $[29] !== tryToFocusAndScrollActiveCommentCallback) {
        t8 = {
            callback: tryToFocusAndScrollActiveCommentCallback,
            elementRef: rendererRef,
            skip: t7
        };
        $[27] = rendererRef;
        $[28] = t7;
        $[29] = tryToFocusAndScrollActiveCommentCallback;
        $[30] = t8;
    } else t8 = $[30];
    (0, $1ZGYV.useRetryOnMutation)(t8);
    let t9;
    if ($[31] !== commentId || $[32] !== isCommentNotFound || $[33] !== navigateToActiveInlineComment || $[34] !== onReplyToCommentReady || $[35] !== queryParamData || $[36] !== queryParamDataExt || $[37] !== rendererActions || $[38] !== setCommentContainerToFocus || $[39] !== setCurrentlySelectedThreadKey || $[40] !== showCommentsPanel) {
        t9 = ()=>{
            if (!queryParamData || hasHandledCommentLink.current) return;
            const { location: location_0 } = queryParamData;
            const { annotationId: annotationId_1 } = queryParamDataExt;
            if (location_0) {
                if (queryParamDataExt.isResolved) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    if (annotationId_1) {
                        setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                        setCommentContainerToFocus(commentId ?? undefined);
                    }
                } else if (annotationId_1) {
                    if (!rendererActions) return;
                    const marks = rendererActions.getAnnotationMarks();
                    if (!marks || marks.length === 0) return;
                    const annotationExists = marks?.some((mark_0)=>mark_0.attrs?.id === annotationId_1);
                    if (!annotationExists) {
                        setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                        setCommentContainerToFocus(commentId ?? undefined);
                        showCommentsPanel({
                            openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                        });
                        (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
                        hasHandledCommentLink.current = true;
                        return;
                    } else if ((0, $6mKj3.expValEquals)("confluence_comment_panel_inlinecomment_qp", "isEnabled", true)) {
                        navigateToActiveInlineComment();
                        return;
                    }
                }
            } else {
                if ((0, $6mKj3.expValEquals)("confluence_comment_improve_comment_deeplink", "isEnabled", true)) {
                    if (!rendererActions || annotationId_1 && isCommentNotFound === undefined) return;
                }
                if (!rendererActions && (0, $6mKj3.expValEquals)("confluence_comment_improve_comment_deeplink", "isEnabled", true)) return;
                const annotationExists_0 = rendererActions?.getAnnotationMarks()?.some((mark_1)=>mark_1.attrs?.id === annotationId_1);
                if (annotationId_1 && !annotationExists_0) {
                    setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
                }
                hasHandledCommentLink.current = true;
            }
        };
        $[31] = commentId;
        $[32] = isCommentNotFound;
        $[33] = navigateToActiveInlineComment;
        $[34] = onReplyToCommentReady;
        $[35] = queryParamData;
        $[36] = queryParamDataExt;
        $[37] = rendererActions;
        $[38] = setCommentContainerToFocus;
        $[39] = setCurrentlySelectedThreadKey;
        $[40] = showCommentsPanel;
        $[41] = t9;
    } else t9 = $[41];
    let t10;
    if ($[42] !== commentId || $[43] !== isCommentNotFound || $[44] !== navigateToActiveInlineComment || $[45] !== onReplyToCommentReady || $[46] !== orderedActiveAnnotationIdList || $[47] !== queryParamData || $[48] !== queryParamDataExt || $[49] !== rendererActions || $[50] !== setCommentContainerToFocus || $[51] !== setCurrentlySelectedThreadKey || $[52] !== showCommentsPanel) {
        t10 = [
            queryParamData,
            rendererActions,
            orderedActiveAnnotationIdList,
            queryParamDataExt,
            showCommentsPanel,
            setCurrentlySelectedThreadKey,
            setCommentContainerToFocus,
            commentId,
            isCommentNotFound,
            onReplyToCommentReady,
            navigateToActiveInlineComment
        ];
        $[42] = commentId;
        $[43] = isCommentNotFound;
        $[44] = navigateToActiveInlineComment;
        $[45] = onReplyToCommentReady;
        $[46] = orderedActiveAnnotationIdList;
        $[47] = queryParamData;
        $[48] = queryParamDataExt;
        $[49] = rendererActions;
        $[50] = setCommentContainerToFocus;
        $[51] = setCurrentlySelectedThreadKey;
        $[52] = showCommentsPanel;
        $[53] = t10;
    } else t10 = $[53];
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    let t12;
    if ($[54] !== commentId || $[55] !== flags || $[56] !== isCommentNotFound) {
        t11 = ()=>{
            if (isCommentNotFound) flags.showWarningFlag({
                id: `viewpage-comment-link-not-found-${commentId}`,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
            });
        };
        t12 = [
            commentId,
            flags,
            isCommentNotFound
        ];
        $[54] = commentId;
        $[55] = flags;
        $[56] = isCommentNotFound;
        $[57] = t11;
        $[58] = t12;
    } else {
        t11 = $[57];
        t12 = $[58];
    }
    (0, $cozmU.useEffect)(t11, t12);
    return null;
} : ({ commentId: commentId, rendererRef: rendererRef, flags: flags, data: data })=>{
    const hasHandledCommentLink = (0, $cozmU.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const { replyToCommentId: replyToCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)();
    const { foundComment: foundComment, isResolved: _ignored, parentComment: parentComment } = data;
    const queryParamData = (0, $cozmU.useMemo)(()=>{
        if (!data.commentError && !data.commentLoading && foundComment) {
            const location = foundComment.location ?? undefined;
            const pid = foundComment.parentId;
            const parentLocation = pid && !data.parentError && !data.parentLoading && parentComment ? parentComment.location ?? undefined : undefined;
            if (!pid || parentComment) return {
                location: location,
                parentId: pid,
                parentLocation: parentLocation
            };
        }
        return undefined;
    }, [
        data.commentError,
        data.commentLoading,
        foundComment,
        data.parentError,
        data.parentLoading,
        parentComment
    ]);
    const queryParamDataExt = (0, $cozmU.useMemo)(()=>{
        const { location: loc, parentLocation: pLoc } = queryParamData || {};
        return loc?.inlineMarkerRef ? {
            annotationId: loc.inlineMarkerRef,
            isResolved: Boolean(loc.inlineResolveProperties?.resolved)
        } : {
            annotationId: pLoc?.inlineMarkerRef,
            isResolved: Boolean(pLoc?.inlineResolveProperties?.resolved)
        };
    }, [
        queryParamData
    ]);
    const onReplyToCommentReady = (0, $cozmU.useCallback)(()=>{
        if (!replyToCommentId) return;
        if (foundComment) {
            const annotationId = queryParamDataExt?.annotationId;
            if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
            const author = foundComment?.author;
            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, true));
        }
    }, [
        replyToCommentId,
        foundComment,
        queryParamDataExt,
        setReplyToCommentId,
        setCurrentlySelectedThreadKey
    ]);
    const navigateToActiveInlineComment = (0, $cozmU.useCallback)(()=>{
        const { annotationId: annotationId_0 } = queryParamDataExt;
        showCommentsPanel({
            openWithView: (0, $3mVfX.ViewValues).OPEN
        });
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const mark = document.querySelector(`[data-id="${annotationId_0}"]`);
        (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
            context: (0, $9FoVw.NavigationContext).RENDERER,
            block: 'center',
            inline: 'center',
            commentId: commentId ?? undefined,
            annotationId: annotationId_0,
            commentType: 'INLINE',
            annotationClicked: true,
            expectedView: (0, $3mVfX.ViewValues).OPEN,
            isReply: Boolean(queryParamData?.parentId)
        }).then((success)=>{
            if (!success && mark) {
                (0, $a33Aa.abortAll)('new_interaction', 'focused-comment-scroll');
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        });
        setCurrentlySelectedThreadKey(annotationId_0 ?? '', (0, $kgNLQ.CommentType).INLINE);
        (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
        hasHandledCommentLink.current = true;
    }, [
        queryParamData,
        queryParamDataExt,
        commentId,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        onReplyToCommentReady
    ]);
    const tryToFocusAndScrollActiveCommentCallback = (0, $cozmU.useCallback)(()=>{
        return $4d5518b698c93929$var$tryToFocusAndScrollActiveComment({
            parentId: queryParamData?.parentId,
            annotationId: queryParamDataExt?.annotationId || null,
            commentId: commentId || null
        });
    }, [
        queryParamData,
        queryParamDataExt,
        commentId
    ]);
    (0, $1ZGYV.useRetryOnMutation)({
        callback: tryToFocusAndScrollActiveCommentCallback,
        elementRef: rendererRef,
        skip: !commentId || !queryParamData || queryParamDataExt.isResolved
    });
    (0, $cozmU.useEffect)(()=>{
        if (!queryParamData || hasHandledCommentLink.current) return;
        const { location: location_0 } = queryParamData;
        const { annotationId: annotationId_1 } = queryParamDataExt;
        if (location_0) {
            if (queryParamDataExt.isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (annotationId_1) {
                    setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                }
            } else if (annotationId_1) {
                // rendererActions is populated asynchronously — wait for it before checking
                // annotation marks, otherwise we'd incorrectly treat active comments as dangling.
                if (!rendererActions) return;
                // Comment exists in DB but annotation mark may be gone from page content (deleted content).
                // Check if annotation mark exists in renderer; if not, open DELETED_CONTENT panel.
                const marks = rendererActions.getAnnotationMarks();
                // The renderer can briefly report ZERO marks while it (re)hydrates the document during
                // load (observed transitioning 6 -> 0 -> 6). Concluding "dangling" during that window
                // opens an empty DELETED_CONTENT panel and latches it via hasHandledCommentLink, so it
                // never recovers. Requiring at least one mark closes that race — this is the view-path
                // counterpart of the editor fix for bug #19 (which uses annotations.length > 0). A
                // genuinely dangling comment on a page with other comments still has their marks present.
                if (!marks || marks.length === 0) return;
                const annotationExists = marks?.some((mark_0)=>mark_0.attrs?.id === annotationId_1);
                if (!annotationExists) {
                    setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
                    hasHandledCommentLink.current = true;
                    return;
                } else if ((0, $6mKj3.expValEquals)('confluence_comment_panel_inlinecomment_qp', 'isEnabled', true)) {
                    // Active inline comment with annotation mark present — open panel and navigate to it.
                    navigateToActiveInlineComment();
                    return;
                }
            }
        } else {
            if ((0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) {
                if (!rendererActions || annotationId_1 && isCommentNotFound === undefined) return;
            }
            if (!rendererActions && (0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) return;
            const annotationExists_0 = rendererActions?.getAnnotationMarks()?.some((mark_1)=>mark_1.attrs?.id === annotationId_1);
            if (annotationId_1 && !annotationExists_0) {
                setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                setCommentContainerToFocus(commentId ?? undefined);
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
            }
            hasHandledCommentLink.current = true;
        }
    }, [
        queryParamData,
        rendererActions,
        orderedActiveAnnotationIdList,
        queryParamDataExt,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        setCommentContainerToFocus,
        commentId,
        isCommentNotFound,
        onReplyToCommentReady,
        navigateToActiveInlineComment
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isCommentNotFound) flags.showWarningFlag({
            id: `viewpage-comment-link-not-found-${commentId}`,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
        });
    }, [
        commentId,
        flags,
        isCommentNotFound
    ]);
    return null;
};
// Helper (kept private — only used by InlineCommentHandler)
const $4d5518b698c93929$var$tryToFocusAndScrollActiveComment = ({ parentId: parentId, annotationId: annotationId, commentId: commentId })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const mark = document.querySelector(`[data-id="${annotationId}"]`);
    if (mark) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        if (focusedMarkerRef?.id !== annotationId) {
            const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
            (0, $aHcFH.checkElementExpand)(mark, true);
            emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: [
                    annotationId
                ],
                eventTarget: mark
            });
        }
        if (commentId) {
            const success = (0, $9FoVw.handleDeepLinkNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: 'center',
                markElement: mark,
                commentId: commentId
            });
            if (!success) {
                (0, $a33Aa.abortAll)('new_interaction', 'focused-comment-scroll');
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        } else if (!parentId) {
            (0, $a33Aa.abortAll)('new_interaction', 'focused-comment-scroll');
            (0, $aHcFH.scrollToElementWithViewingRoom)({
                element: mark,
                useInstantScroll: true
            });
        }
    }
    return !!mark;
};
const $4d5518b698c93929$var$ObjectCommentHandler = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(45);
    const { commentId: commentId, focusedCommentId: focusedCommentId, replyToComment: replyToComment, hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, data: data } = t0;
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $cozmU.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $cozmU.useState)(false);
    const mutationObserverRef = (0, $cozmU.useRef)(null);
    const scrollTimeoutRef = (0, $cozmU.useRef)(null);
    const lastMutationTimeRef = (0, $cozmU.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (scrollTimeoutRef.current !== null) {
                if (typeof scrollTimeoutRef.current === "number") {
                    if (typeof window !== "undefined" && "cancelIdleCallback" in window) window.cancelIdleCallback(scrollTimeoutRef.current);
                } else clearTimeout(scrollTimeoutRef.current);
                scrollTimeoutRef.current = null;
            }
        };
        $[0] = t1;
    } else t1 = $[0];
    const clearScrollTimeout = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (mutationObserverRef.current) {
                mutationObserverRef.current.disconnect();
                mutationObserverRef.current = null;
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const cleanupMutationObserver = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (mutationObserverRef.current) cleanupMutationObserver();
            if (scrollTimeoutRef.current !== null) clearScrollTimeout();
        };
        $[2] = t3;
    } else t3 = $[2];
    const cleanupScrollResources = t3;
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { isDataProcessed: isDataProcessed, allComments: allComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    const { isResolved: isResolved, parentId: parentId, foundComment: comment, commentError: commentError } = data;
    let t4;
    if ($[3] !== allComments || $[4] !== allObjectCommentsRendered || $[5] !== comment || $[6] !== commentError || $[7] !== commentId || $[8] !== focusedCommentId || $[9] !== hasLoadedObjectComments || $[10] !== hasScrolledToFocusedComment || $[11] !== hasScrolledToReplyComment || $[12] !== isDataProcessed || $[13] !== isResolved || $[14] !== parentId || $[15] !== replyToComment || $[16] !== setCurrentlySelectedThreadKey || $[17] !== setReplyToCommentId || $[18] !== showCommentsPanel) {
        t4 = ()=>{
            const hasData = comment && !commentError;
            if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                let rootCommentId;
                if (isDataProcessed && allComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId)?.id;
                if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
            }
            if (hasData && commentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_queryparam_selection", "isEnabled", true)) {
                const location = comment?.location;
                if (location && "type" in location && location.type === "INLINE") return;
            }
            if (commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
                if (isResolved) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    setCurrentlySelectedThreadKey(commentId, (0, $kgNLQ.CommentType).GENERAL);
                    if (focusedCommentId) setHasScrolledToFocusedComment(true);
                    else setHasScrolledToReplyComment(true);
                } else {
                    const commentElementId = `footer-comment-thread-${commentId}-container`;
                    const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                    let threadToBeSelected = commentId;
                    if (parentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                        let rootCommentId_0;
                        if (isDataProcessed && allComments.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId)?.id;
                        threadToBeSelected = rootCommentId_0 ?? parentId;
                    }
                    if (commentId) {
                        if ((0, $6mKj3.expValEquals)("confluence_comment_deeplink_delay_scroll", "isEnabled", true)) {
                            if (replyToComment) {
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                const author = comment?.author;
                                setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true)));
                                setHasScrolledToReplyComment(true);
                                return;
                            }
                            cleanupMutationObserver();
                            const getDocumentScrollHeight = $4d5518b698c93929$var$_temp;
                            const scrollToComment = ()=>{
                                const el = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (el && (0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) getDocumentScrollHeight();
                                showCommentsPanel({
                                    openWithView: (0, $3mVfX.ViewValues).OPEN
                                });
                                (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                    scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                                    context: (0, $9FoVw.NavigationContext).PANEL,
                                    block: "center",
                                    inline: "center",
                                    commentId: commentId,
                                    annotationId: threadToBeSelected,
                                    commentType: "FOOTER",
                                    annotationClicked: true,
                                    expectedView: (0, $3mVfX.ViewValues).OPEN,
                                    isReply: Boolean(parentId)
                                });
                                setHasScrolledToFocusedComment(true);
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                cleanupMutationObserver();
                            };
                            const performScrollAndCleanup = ()=>{
                                clearScrollTimeout();
                                if ((0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) requestAnimationFrame(()=>requestAnimationFrame(scrollToComment));
                                else scrollToComment();
                            };
                            const checkHeightStabilityThenScroll = ()=>{
                                if (!(0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) {
                                    performScrollAndCleanup();
                                    return;
                                }
                                const h1 = getDocumentScrollHeight();
                                scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    const h2 = getDocumentScrollHeight();
                                    if (h1 === h2) performScrollAndCleanup();
                                    else scheduleScroll();
                                }, $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS);
                            };
                            const scheduleScroll = ()=>{
                                clearScrollTimeout();
                                lastMutationTimeRef.current = Date.now();
                                if (typeof window !== "undefined" && "requestIdleCallback" in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                    const checkStabilityAndScroll = ()=>{
                                        const timeSince = Date.now() - lastMutationTimeRef.current;
                                        if (timeSince >= $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS) checkHeightStabilityThenScroll();
                                        else scrollTimeoutRef.current = setTimeout(()=>{
                                            scrollTimeoutRef.current = null;
                                            checkStabilityAndScroll();
                                        }, $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS - timeSince);
                                    };
                                    checkStabilityAndScroll();
                                });
                                else scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    checkHeightStabilityThenScroll();
                                }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                            };
                            const getElementAndCheckReady = ()=>{
                                const el_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (!el_0) return {
                                    element: null,
                                    isReady: false
                                };
                                const rect = el_0.getBoundingClientRect();
                                return {
                                    element: el_0,
                                    isReady: el_0.offsetHeight > 0 && el_0.offsetWidth > 0 && rect.height > 0 && rect.width > 0
                                };
                            };
                            const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                            if (currentElement && isReady) scheduleScroll();
                            else {
                                mutationObserverRef.current = new MutationObserver(()=>{
                                    lastMutationTimeRef.current = Date.now();
                                    const { element: el_1, isReady: elReady } = getElementAndCheckReady();
                                    if (el_1 && elReady) scheduleScroll();
                                });
                                if (currentElement) {
                                    mutationObserverRef.current.observe(currentElement, {
                                        childList: true,
                                        subtree: true,
                                        attributes: true,
                                        attributeFilter: [
                                            "style",
                                            "class"
                                        ]
                                    });
                                    const parent = currentElement.parentElement;
                                    if (parent) mutationObserverRef.current.observe(parent, {
                                        childList: true,
                                        subtree: true
                                    });
                                } else mutationObserverRef.current.observe(document.body, {
                                    childList: true,
                                    subtree: true
                                });
                                setTimeout(()=>{
                                    if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                                }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                            }
                        } else {
                            const el_2 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (el_2) {
                                showCommentsPanel({
                                    openWithView: (0, $3mVfX.ViewValues).OPEN
                                });
                                (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                    context: (0, $9FoVw.NavigationContext).PANEL,
                                    block: "center",
                                    inline: "center",
                                    commentId: commentId,
                                    annotationId: threadToBeSelected,
                                    commentType: "FOOTER",
                                    annotationClicked: true,
                                    expectedView: (0, $3mVfX.ViewValues).OPEN,
                                    isReply: Boolean(parentId)
                                });
                                setHasScrolledToFocusedComment(true);
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                            }
                        }
                    }
                }
            }
        };
        $[3] = allComments;
        $[4] = allObjectCommentsRendered;
        $[5] = comment;
        $[6] = commentError;
        $[7] = commentId;
        $[8] = focusedCommentId;
        $[9] = hasLoadedObjectComments;
        $[10] = hasScrolledToFocusedComment;
        $[11] = hasScrolledToReplyComment;
        $[12] = isDataProcessed;
        $[13] = isResolved;
        $[14] = parentId;
        $[15] = replyToComment;
        $[16] = setCurrentlySelectedThreadKey;
        $[17] = setReplyToCommentId;
        $[18] = showCommentsPanel;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== allComments || $[21] !== allObjectCommentsRendered || $[22] !== comment || $[23] !== commentBatchCount || $[24] !== commentBatchRendered || $[25] !== commentError || $[26] !== commentId || $[27] !== focusedCommentId || $[28] !== hasLoadedObjectComments || $[29] !== hasScrolledToFocusedComment || $[30] !== hasScrolledToReplyComment || $[31] !== isDataProcessed || $[32] !== isResolved || $[33] !== parentId || $[34] !== replyToComment || $[35] !== setCurrentlySelectedThreadKey || $[36] !== setReplyToCommentId || $[37] !== showCommentsPanel) {
        t5 = [
            comment,
            commentError,
            hasLoadedObjectComments,
            commentId,
            focusedCommentId,
            replyToComment,
            allObjectCommentsRendered,
            commentBatchRendered,
            commentBatchCount,
            setCurrentlySelectedThreadKey,
            setReplyToCommentId,
            isResolved,
            showCommentsPanel,
            hasScrolledToFocusedComment,
            hasScrolledToReplyComment,
            parentId,
            isDataProcessed,
            allComments,
            cleanupMutationObserver,
            clearScrollTimeout
        ];
        $[20] = allComments;
        $[21] = allObjectCommentsRendered;
        $[22] = comment;
        $[23] = commentBatchCount;
        $[24] = commentBatchRendered;
        $[25] = commentError;
        $[26] = commentId;
        $[27] = focusedCommentId;
        $[28] = hasLoadedObjectComments;
        $[29] = hasScrolledToFocusedComment;
        $[30] = hasScrolledToReplyComment;
        $[31] = isDataProcessed;
        $[32] = isResolved;
        $[33] = parentId;
        $[34] = replyToComment;
        $[35] = setCurrentlySelectedThreadKey;
        $[36] = setReplyToCommentId;
        $[37] = showCommentsPanel;
        $[38] = t5;
    } else t5 = $[38];
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setHasScrolledToFocusedComment(false);
            setHasScrolledToReplyComment(false);
            cleanupScrollResources();
        };
        $[39] = t6;
    } else t6 = $[39];
    let t7;
    if ($[40] !== focusedCommentId || $[41] !== replyToComment) {
        t7 = [
            focusedCommentId,
            replyToComment,
            cleanupScrollResources
        ];
        $[40] = focusedCommentId;
        $[41] = replyToComment;
        $[42] = t7;
    } else t7 = $[42];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>()=>cleanupScrollResources();
        t9 = [
            cleanupScrollResources
        ];
        $[43] = t8;
        $[44] = t9;
    } else {
        t8 = $[43];
        t9 = $[44];
    }
    (0, $cozmU.useEffect)(t8, t9);
    return null;
} : ({ commentId: commentId, focusedCommentId: focusedCommentId, replyToComment: replyToComment, hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, data: data })=>{
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $cozmU.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $cozmU.useState)(false);
    const mutationObserverRef = (0, $cozmU.useRef)(null);
    const scrollTimeoutRef = (0, $cozmU.useRef)(null);
    const lastMutationTimeRef = (0, $cozmU.useRef)(0);
    const clearScrollTimeout = (0, $cozmU.useCallback)(()=>{
        if (scrollTimeoutRef.current !== null) {
            if (typeof scrollTimeoutRef.current === 'number') {
                if (typeof window !== 'undefined' && 'cancelIdleCallback' in window) window.cancelIdleCallback(scrollTimeoutRef.current);
            } else clearTimeout(scrollTimeoutRef.current);
            scrollTimeoutRef.current = null;
        }
    }, []);
    const cleanupMutationObserver = (0, $cozmU.useCallback)(()=>{
        if (mutationObserverRef.current) {
            mutationObserverRef.current.disconnect();
            mutationObserverRef.current = null;
        }
    }, []);
    const cleanupScrollResources = (0, $cozmU.useCallback)(()=>{
        if (mutationObserverRef.current) cleanupMutationObserver();
        if (scrollTimeoutRef.current !== null) clearScrollTimeout();
    }, [
        cleanupMutationObserver,
        clearScrollTimeout
    ]);
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { isDataProcessed: isDataProcessed, allComments: allComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    const { isResolved: isResolved, parentId: parentId, foundComment: comment, commentError: commentError } = data;
    // Handle scrolling to focused/replyTo comment after the data is loaded
    (0, $cozmU.useEffect)(()=>{
        const hasData = comment && !commentError;
        // Update currentlySelectedThreadKey to root comment for replies (after scroll)
        if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
            let rootCommentId;
            if (isDataProcessed && allComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId)?.id;
            if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
        }
        // Early return if this is actually an INLINE comment — handled by InlineCommentHandler
        if (hasData && commentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_queryparam_selection', 'isEnabled', true)) {
            const location = comment?.location;
            if (location && 'type' in location && location.type === 'INLINE') return;
        }
        if (commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
            if (isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                setCurrentlySelectedThreadKey(commentId, (0, $kgNLQ.CommentType).GENERAL);
                if (focusedCommentId) setHasScrolledToFocusedComment(true);
                else setHasScrolledToReplyComment(true);
            } else {
                const commentElementId = `footer-comment-thread-${commentId}-container`;
                const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                let threadToBeSelected = commentId;
                if (parentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
                    let rootCommentId_0;
                    if (isDataProcessed && allComments.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId)?.id;
                    threadToBeSelected = rootCommentId_0 ?? parentId;
                }
                if (commentId) {
                    if ((0, $6mKj3.expValEquals)('confluence_comment_deeplink_delay_scroll', 'isEnabled', true)) {
                        if (replyToComment) {
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            const author = comment?.author;
                            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true)));
                            setHasScrolledToReplyComment(true);
                            return;
                        }
                        cleanupMutationObserver();
                        const getDocumentScrollHeight = ()=>Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
                        const scrollToComment = ()=>{
                            const el = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (el && (0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                el.offsetTop;
                                getDocumentScrollHeight();
                            }
                            showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                annotationId: threadToBeSelected,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).OPEN,
                                isReply: Boolean(parentId)
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            cleanupMutationObserver();
                        };
                        const performScrollAndCleanup = ()=>{
                            clearScrollTimeout();
                            if ((0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) requestAnimationFrame(()=>requestAnimationFrame(scrollToComment));
                            else scrollToComment();
                        };
                        const checkHeightStabilityThenScroll = ()=>{
                            if (!(0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                performScrollAndCleanup();
                                return;
                            }
                            const h1 = getDocumentScrollHeight();
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                const h2 = getDocumentScrollHeight();
                                if (h1 === h2) performScrollAndCleanup();
                                else scheduleScroll();
                            }, $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS);
                        };
                        const scheduleScroll = ()=>{
                            clearScrollTimeout();
                            lastMutationTimeRef.current = Date.now();
                            if (typeof window !== 'undefined' && 'requestIdleCallback' in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                const checkStabilityAndScroll = ()=>{
                                    const timeSince = Date.now() - lastMutationTimeRef.current;
                                    if (timeSince >= $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS) checkHeightStabilityThenScroll();
                                    else scrollTimeoutRef.current = setTimeout(()=>{
                                        scrollTimeoutRef.current = null;
                                        checkStabilityAndScroll();
                                    }, $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS - timeSince);
                                };
                                checkStabilityAndScroll();
                            });
                            else scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                checkHeightStabilityThenScroll();
                            }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                        };
                        const getElementAndCheckReady = ()=>{
                            const el_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (!el_0) return {
                                element: null,
                                isReady: false
                            };
                            const rect = el_0.getBoundingClientRect();
                            return {
                                element: el_0,
                                isReady: el_0.offsetHeight > 0 && el_0.offsetWidth > 0 && rect.height > 0 && rect.width > 0
                            };
                        };
                        const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                        if (currentElement && isReady) scheduleScroll();
                        else {
                            mutationObserverRef.current = new MutationObserver(()=>{
                                lastMutationTimeRef.current = Date.now();
                                const { element: el_1, isReady: elReady } = getElementAndCheckReady();
                                if (el_1 && elReady) scheduleScroll();
                            });
                            if (currentElement) {
                                mutationObserverRef.current.observe(currentElement, {
                                    childList: true,
                                    subtree: true,
                                    attributes: true,
                                    attributeFilter: [
                                        'style',
                                        'class'
                                    ]
                                });
                                const parent = currentElement.parentElement;
                                if (parent) mutationObserverRef.current.observe(parent, {
                                    childList: true,
                                    subtree: true
                                });
                            } else mutationObserverRef.current.observe(document.body, {
                                childList: true,
                                subtree: true
                            });
                            setTimeout(()=>{
                                if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                            }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                        }
                    } else {
                        const el_2 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                        if (el_2) {
                            showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                annotationId: threadToBeSelected,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).OPEN,
                                isReply: Boolean(parentId)
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                        }
                    }
                }
            }
        }
    }, [
        comment,
        commentError,
        hasLoadedObjectComments,
        commentId,
        focusedCommentId,
        replyToComment,
        allObjectCommentsRendered,
        commentBatchRendered,
        commentBatchCount,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        isResolved,
        showCommentsPanel,
        hasScrolledToFocusedComment,
        hasScrolledToReplyComment,
        parentId,
        isDataProcessed,
        allComments,
        cleanupMutationObserver,
        clearScrollTimeout
    ]);
    // Reset scroll tracking when focusedCommentId or replyToComment changes
    (0, $cozmU.useEffect)(()=>{
        setHasScrolledToFocusedComment(false);
        setHasScrolledToReplyComment(false);
        cleanupScrollResources();
    }, [
        focusedCommentId,
        replyToComment,
        cleanupScrollResources
    ]);
    // Clean up MutationObserver and timeout on unmount
    (0, $cozmU.useEffect)(()=>()=>cleanupScrollResources(), [
        cleanupScrollResources
    ]);
    return null;
};
const $4d5518b698c93929$export$c21fa150171418d7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isArchived: t1, rendererRef: rendererRef, hasLoadedObjectComments: t2, allObjectCommentsRendered: t3, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, flags: flags } = t0;
    const isArchived = t1 === undefined ? false : t1;
    const hasLoadedObjectComments = t2 === undefined ? false : t2;
    const allObjectCommentsRendered = t3 === undefined ? false : t3;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { focusedCommentId: inlineFocusedId, replyToCommentId: replyToCommentId, editCommentId: editCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const focusedCommentIdQP = $4d5518b698c93929$var$useFocusedCommentIdQueryParam();
    const replyToCommentQP = $4d5518b698c93929$var$useReplyToCommentQueryParam();
    const commentId = inlineFocusedId || replyToCommentId || editCommentId || focusedCommentIdQP || replyToCommentQP;
    let t4;
    if ($[0] !== commentId || $[1] !== contentId) {
        t4 = {
            commentId: commentId,
            contentId: contentId
        };
        $[0] = commentId;
        $[1] = contentId;
        $[2] = t4;
    } else t4 = $[2];
    const sharedData = $4d5518b698c93929$var$useCommentQueryParamsData(t4);
    const commentLocationType = sharedData.foundComment?.location?.type;
    const isInlineComment = !commentLocationType || commentLocationType === "INLINE";
    if (isInlineComment && rendererRef) {
        let t5;
        if ($[3] !== commentId || $[4] !== flags || $[5] !== isArchived || $[6] !== rendererRef || $[7] !== sharedData) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d5518b698c93929$var$InlineCommentHandler, {
                commentId: commentId,
                isArchived: isArchived,
                rendererRef: rendererRef,
                flags: flags,
                data: sharedData
            });
            $[3] = commentId;
            $[4] = flags;
            $[5] = isArchived;
            $[6] = rendererRef;
            $[7] = sharedData;
            $[8] = t5;
        } else t5 = $[8];
        return t5;
    }
    if (!isInlineComment) {
        const t5 = focusedCommentIdQP || inlineFocusedId;
        const t6 = replyToCommentQP || replyToCommentId;
        let t7;
        if ($[9] !== allObjectCommentsRendered || $[10] !== commentBatchCount || $[11] !== commentBatchRendered || $[12] !== commentId || $[13] !== hasLoadedObjectComments || $[14] !== sharedData || $[15] !== t5 || $[16] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d5518b698c93929$var$ObjectCommentHandler, {
                commentId: commentId,
                focusedCommentId: t5,
                replyToComment: t6,
                hasLoadedObjectComments: hasLoadedObjectComments,
                allObjectCommentsRendered: allObjectCommentsRendered,
                commentBatchRendered: commentBatchRendered,
                commentBatchCount: commentBatchCount,
                data: sharedData
            });
            $[9] = allObjectCommentsRendered;
            $[10] = commentBatchCount;
            $[11] = commentBatchRendered;
            $[12] = commentId;
            $[13] = hasLoadedObjectComments;
            $[14] = sharedData;
            $[15] = t5;
            $[16] = t6;
            $[17] = t7;
        } else t7 = $[17];
        return t7;
    }
    return null;
} : ({ isArchived: isArchived = false, rendererRef: rendererRef, hasLoadedObjectComments: hasLoadedObjectComments = false, allObjectCommentsRendered: allObjectCommentsRendered = false, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    // Inline query params (used for InlineCommentHandler + shared commentId)
    const { focusedCommentId: inlineFocusedId, replyToCommentId: replyToCommentId, editCommentId: editCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    // Object query params
    const focusedCommentIdQP = $4d5518b698c93929$var$useFocusedCommentIdQueryParam();
    const replyToCommentQP = $4d5518b698c93929$var$useReplyToCommentQueryParam();
    // Unified commentId: prefer inline params, fall back to object params
    const commentId = inlineFocusedId || replyToCommentId || editCommentId || focusedCommentIdQP || replyToCommentQP;
    // Single shared data fetch — one query for all comment types
    const sharedData = $4d5518b698c93929$var$useCommentQueryParamsData({
        commentId: commentId,
        contentId: contentId
    });
    // Determine comment type from the comment location
    const commentLocationType = sharedData.foundComment?.location?.type;
    // Treat undefined (not yet loaded) as INLINE to satisfy InlineCommentHandler
    // which handles the "not found" case. Once loaded, route based on actual type.
    const isInlineComment = !commentLocationType || commentLocationType === 'INLINE';
    if (isInlineComment && rendererRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d5518b698c93929$var$InlineCommentHandler, {
        commentId: commentId,
        isArchived: isArchived,
        rendererRef: rendererRef,
        flags: flags,
        data: sharedData
    });
    if (!isInlineComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d5518b698c93929$var$ObjectCommentHandler, {
        commentId: commentId,
        focusedCommentId: focusedCommentIdQP || inlineFocusedId,
        replyToComment: replyToCommentQP || replyToCommentId,
        hasLoadedObjectComments: hasLoadedObjectComments,
        allObjectCommentsRendered: allObjectCommentsRendered,
        commentBatchRendered: commentBatchRendered,
        commentBatchCount: commentBatchCount,
        data: sharedData
    });
    return null;
};
const $4d5518b698c93929$export$d7e13e4fc19ecc08 = (0, $7aRa9.withFlags)($4d5518b698c93929$export$c21fa150171418d7);
function $4d5518b698c93929$var$_temp() {
    return Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
}
module.exports["CommentQueryParamsListener"] = $4d5518b698c93929$export$d7e13e4fc19ecc08;

});

parcelRegister("1ZGYV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION = 20000;
const $b6108840e0d320f3$var$USER_INTERACTION_EVENTS = [
    'mousedown',
    'keydown',
    'wheel',
    'touchstart'
];
const $b6108840e0d320f3$export$544875121493f258 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { callback: callback, elementRef: elementRef, skip: skip } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const stopObserverCallbacks = (0, $cozmU.useRef)(t1);
    const mutationEndTimer = (0, $cozmU.useRef)(0);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (_reason)=>{
            stopObserverCallbacks.current.forEach($b6108840e0d320f3$var$_temp);
            stopObserverCallbacks.current = [];
            if (mutationEndTimer.current !== 0) {
                window.clearTimeout(mutationEndTimer.current);
                mutationEndTimer.current = 0;
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const stopMonitoring = t2;
    let t3;
    if ($[2] !== callback || $[3] !== elementRef) {
        t3 = ()=>{
            if (!stopObserverCallbacks.current.length && elementRef?.current) {
                const mutationObserver = new MutationObserver(()=>{
                    window.clearTimeout(mutationEndTimer.current);
                    mutationEndTimer.current = window.setTimeout(()=>{
                        stopMonitoring("Deep link target never found");
                    }, $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION);
                    if (callback()) stopMonitoring("Callback succeeded");
                });
                mutationObserver.observe(elementRef.current, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true
                });
                stopObserverCallbacks.current.push(()=>{
                    mutationObserver.disconnect();
                });
                $b6108840e0d320f3$var$USER_INTERACTION_EVENTS.forEach((name)=>{
                    const userInteractionHandler = ()=>stopMonitoring("User interaction");
                    window.addEventListener(name, userInteractionHandler, true);
                    stopObserverCallbacks.current.push(()=>{
                        window.removeEventListener(name, userInteractionHandler, true);
                    });
                });
            }
        };
        $[2] = callback;
        $[3] = elementRef;
        $[4] = t3;
    } else t3 = $[4];
    const startMonitoring = t3;
    let t4;
    let t5;
    if ($[5] !== callback || $[6] !== elementRef || $[7] !== skip || $[8] !== startMonitoring) {
        t4 = ()=>{
            if (skip || !elementRef?.current) return;
            if (callback()) return;
            startMonitoring();
            return ()=>{
                stopMonitoring("Canceled by unmount");
            };
        };
        t5 = [
            elementRef,
            callback,
            skip,
            startMonitoring,
            stopMonitoring
        ];
        $[5] = callback;
        $[6] = elementRef;
        $[7] = skip;
        $[8] = startMonitoring;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
} : ({ callback: callback, elementRef: elementRef, skip: skip })=>{
    const stopObserverCallbacks = (0, $cozmU.useRef)([]);
    const mutationEndTimer = (0, $cozmU.useRef)(0);
    const stopMonitoring = (0, $cozmU.useCallback)((_reason)=>{
        stopObserverCallbacks.current.forEach((stop)=>{
            stop();
        });
        stopObserverCallbacks.current = [];
        if (mutationEndTimer.current !== 0) {
            window.clearTimeout(mutationEndTimer.current);
            mutationEndTimer.current = 0;
        }
    }, []);
    const startMonitoring = (0, $cozmU.useCallback)(()=>{
        if (!stopObserverCallbacks.current.length && elementRef?.current) {
            const mutationObserver = new MutationObserver(()=>{
                // Every time there's a change, restart the timer that ends watching for mutations
                // (keep the observer going until changes stop for a while).
                window.clearTimeout(mutationEndTimer.current);
                mutationEndTimer.current = window.setTimeout(()=>{
                    // De-bouncing ended. Timeout finally running, time to stop observing and trying to follow the anchor
                    stopMonitoring('Deep link target never found');
                }, $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION);
                if (callback()) // If the callback succeeded, stop monitoring
                stopMonitoring('Callback succeeded');
            });
            mutationObserver.observe(elementRef.current, {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true
            });
            stopObserverCallbacks.current.push(()=>{
                mutationObserver.disconnect();
            });
            // Listen for user interaction to end checking for changes
            $b6108840e0d320f3$var$USER_INTERACTION_EVENTS.forEach((name)=>{
                const userInteractionHandler = ()=>stopMonitoring('User interaction');
                window.addEventListener(name, userInteractionHandler, true);
                stopObserverCallbacks.current.push(()=>{
                    window.removeEventListener(name, userInteractionHandler, true);
                });
            });
        }
    }, [
        elementRef,
        callback,
        stopMonitoring
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Do nothing if skip is true or the elementRef is not set.
        if (skip || !elementRef?.current) return;
        // Try right away in case the page has already settled and there are no mutations to observe.
        if (callback()) return;
        // Watch for changes to the page and call the callback whenever one occurs.
        startMonitoring();
        return ()=>{
            stopMonitoring('Canceled by unmount');
        };
    }, [
        elementRef,
        callback,
        skip,
        startMonitoring,
        stopMonitoring
    ]);
};
function $b6108840e0d320f3$var$_temp(stop) {
    stop();
}
module.exports["useRetryOnMutation"] = $b6108840e0d320f3$export$544875121493f258;

});


//# sourceMappingURL=ObjectCommentContainer.d2106e30.js.map
